import React, { useCallback, useMemo, useState } from "react";

import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  startOfDay,
  startOfMonth,
  startOfWeek,
} from "date-fns";

export const DatesContext = React.createContext();

export const useDatesContext = () => React.useContext(DatesContext);

const CACHE_TIME = 60 * 1000;

export function DatesProvider({ children }) {
  const day = useMemo(
    () => ({
      start: startOfDay(new Date()),
      end: endOfDay(new Date()),
    }),
    []
  );

  const week = useMemo(
    () => ({
      start: startOfWeek(new Date()),
      end: endOfWeek(new Date()),
    }),
    []
  );

  const month = useMemo(
    () => ({
      start: startOfMonth(new Date()),
      end: endOfMonth(new Date()),
    }),
    []
  );

  const [cacheControl, setCacheControl] = useState({});
  const getCacheControl = useCallback(
    (name, cacheTime) => {
      const time = new Date().getTime();
      let update = false;
      if (!cacheControl[name]) {
        update = true;
      } else {
        if (cacheControl[name] + (cacheTime || CACHE_TIME) < time) {
          update = true;
        }
      }
      if (update) {
        setCacheControl({ ...cacheControl, [name]: time });
        return "network-only";
      }
      return "cache-first";
    },
    [cacheControl]
  );

  const value = useMemo(
    () => ({ week, month, day, getCacheControl }),
    [week, month, day, getCacheControl]
  );

  return (
    <DatesContext.Provider value={value}>{children}</DatesContext.Provider>
  );
}
